import { useQuery } from '@tanstack/react-query'

import { fetchPublicSiteBundle } from '@/services/public/publicSiteApi'

export function usePublicSiteBundle() {
  return useQuery({
    queryKey: ['public', 'site'],
    queryFn: fetchPublicSiteBundle,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}
